@if (options()) {
  @if (options().label) {
    <label
      [id]="options().label?.id"
      [for]="!invalidMessage && options().id"
      [class]="'form-label ' + (options().label?.class || '')"
    >
      {{ translations.labels[options().label?.text || 'label'] || options().label?.text }}
      @if (options().required) {
        <span class="required">*</span>
      }
    </label>
  }
  @if (options().values) {
    <select
      #selectEl
      [id]="options().id"
      class="form-select"
      name="itemsPerPage"
      [(ngModel)]="options().model"
      (ngModelChange)="onModelChange($event)"
      [disabled]="options().disabled || false"
    >
      @if (options().values!.length > 0) {
        @for (item of options().values; track item.id; let i = $index) {
          <option
            class="testing"
            [ngValue]="item.id"
          >
            {{ translations[item.value] || item.value }}
          </option>
        }
      }
    </select>
  }
} @else {
  <div
    class="alert alert-danger"
    role="alert"
  >
    <span class="badge rounded-pill bg-secondary">Developer</span>: Cannot instantiate select
    without options() set
  </div>
}
